import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { InactivityTimeoutService } from '../../common/inactivity-timeout.service';

@Component({
  selector: 'app-session-timeout-modal',
  templateUrl: 'session-timeout-modal.component.html',
  styleUrls: ['session-timeout-modal.component.scss']
})
export class SessionTimeoutModalComponent implements OnInit, OnDestroy {
  secondsRemaining: number | null = null;
  private sub: Subscription;

  constructor(private inactivityTimeout: InactivityTimeoutService) { }

  ngOnInit(): void {
    this.sub = this.inactivityTimeout.secondsRemaining$.subscribe(s => this.secondsRemaining = s);
  }

  get visible(): boolean {
    return this.secondsRemaining !== null;
  }

  stayLoggedIn(): void {
    this.inactivityTimeout.extendSession();
  }

  logoutNow(): void {
    this.inactivityTimeout.logoutNow();
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
